module.exports = __webpack_public_path__ + "img/artillery-wagon-base-shadow-9.6a064631.png";